<template>
    <div>
<!--        <van-sticky :offset-top="offsetTop">-->
<!--            <div style="background-color: white; box-shadow: 0 2px 3px #cccccc; ">-->
<!--                <van-checkbox-group v-model="check_result" @change="onCheckBoxChange">-->
<!--                    <van-row style="margin-left: 15px; padding-top: 10px; padding-bottom: 10px">-->
<!--                        <van-col span="12">-->
<!--                            <van-checkbox :name="check_list[0]" shape="round" checked-color="#ff0000">-->
<!--                                {{check_list[0]}}-->
<!--                            </van-checkbox>-->
<!--                        </van-col>-->
<!--                        <van-col span="12">-->
<!--                            <van-checkbox :name="check_list[1]" shape="round" checked-color="#ff0000">-->
<!--                                {{check_list[1]}}-->
<!--                            </van-checkbox>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                </van-checkbox-group>-->
<!--            </div>-->
<!--        </van-sticky>-->

        <div style="margin-top: 10px">
            <div v-if="!data_list || data_list.length === 0" style="text-align: center; padding-top: 10px">
                输入关键字，搜索优惠券商品
            </div>
            <Wp_pull_list ref="Wp_pull_list"
                     :all-params="all_params"
                     :url="url"
                     :page-size="page_size"
                     request-method="GET"
                     :auto-load="auto_load"
                     @onLoad="onLoad"
            >
                <div slot="default">
                    <div v-if="$common.getPid()">
                        <JdSkuInfoCard ref="JdSkuInfoCard"
                                       v-for="(sku_info, index) in data_list"
                                       v-bind:key="index"
                                       :skuInfo="sku_info"
                        ></JdSkuInfoCard>
<!--                        @addInSelectList="addInSelectList"-->
<!--                        @getAllRobatSkuData="getAllRobatSkuData"-->
<!--                        @updataBadegSync="updataBadegSync"-->
                    </div>

                    <div v-else>
                        <JdSkuInfoCard_No_Pid
                                v-for="(sku_info, index) in data_list"
                                v-bind:key="index"
                                :skuInfo="sku_info"
                        ></JdSkuInfoCard_No_Pid>
                    </div>
                </div>
            </Wp_pull_list>

        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_search_model from "../custom/Wp_search_model";
    import Wp_pull_list from "../list/Wp_pull_list";
    import JdSkuInfoCard from "../custom/JdSkuInfoCard";
    import JdSkuInfoCard_No_Pid from "../custom/JdSkuInfoCard_No_Pid";
    export default {
        name: "Wp_jd_select_simple_for_search_model",
        components: {JdSkuInfoCard_No_Pid, JdSkuInfoCard, Wp_pull_list, Wp_search_model, Wp_nav_bar},

        props:{
            offsetTop: {type: Number, default: 0},
            keywords: {type: String, default: ''},
            paramUrl: {type: String, default: ''},
        },

        data(){
            return{
                showNavBar: true,

                search_value: '',

                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,

                all_params:{},
                //上拉加载的临时list
                data_list: [],
                url: '',

                check_list: ['优惠券', '京东自营'],
                check_result: ['优惠券'],

                auto_load: false,

                param_url: "",
            }
        },

        watch:{
            // paramUrl(){
            //     console.log(this.paramUrl)
            //     if(this.paramUrl){
            //         let url = this.paramUrl;
            //         if(url.indexOf("keyword") !== -1){
            //             let sub_str = url.substring(url.indexOf("?") + 1, url.indexOf("&") + 1);
            //             // console.log(sub_str)
            //             this.url = url.replace(sub_str,"");
            //             console.log(this.url)
            //         }
            //     }else{
            //         // this.url = this.$common.goods_query;
            //     }
            // },

            keywords(){
                if(this.keywords){
                    this.all_params.keyword = this.keywords
                }
            }
        },

        created() {
            this.initDatas();
        },

        methods:{

            setUrl(_url){
                this.url = _url
            },

            initDatas(){

                if(this.paramUrl){
                    let url = this.paramUrl;
                    if(url.indexOf("keyword") !== -1){
                        //因为一旦this.url改变，wp_list就会加载，避免重复加载，this.url去掉keyword，通过all_params再请求时添加
                        let sub_str = url.substring(url.indexOf("?") + 1, url.indexOf("&") + 1);
                        // console.log(sub_str)
                        if(url.indexOf("[word]") !== -1){
                            this.all_params.keyword = "";
                        }else{
                            this.all_params.keyword = url.substring(url.indexOf("keyword=") + 8, url.indexOf("&"));
                        }

                        this.url = url.replace(sub_str,"");
                    }
                    this.auto_load = true;
                }else{
                    // this.url = this.$common.goods_query;
                }

                this.initAllParams();
            },

            initAllParams(){
                if(!this.all_params || !this.all_params.page){
                    // this.all_params.app_key = this.$common.getAppKeyInfo('70637').app_key;
                    // this.all_params.app_secret = this.$common.getAppKeyInfo('70637').app_secret;
                    this.all_params.page = this.page_index;
                    this.all_params.size = this.page_size;
                }
                //
                // //选中优惠券
                // if (this.check_result.includes(this.check_list[0])) {
                //     this.all_params.isCoupon = 1;
                // }else{
                //     this.all_params.isCoupon = -1;
                // }
                // //选中京东自营
                // if (this.check_result.includes(this.check_list[1])) {
                //     this.all_params.owner = "g";
                // }else{
                //     this.all_params.owner = "";
                // }

            },

            onLoad(list){
                // this.initSkuListFromRobot();
                //
                // //选品清单重置
                // this.$refs.Wp_select_list_mark_model.releaseSelectData();

                this.data_list = list;
            },

            getSearchValue(value){
                console.log(value)
                this.search_value = value;
            },

            /**
             * 复选框筛选条件改变的回调
             */
            onCheckBoxChange(check_values) {
                // this.initStatus();

                //优惠券
                if (check_values.includes(this.check_list[0])) {
                    this.all_params.isCoupon = 1;
                } else {
                    this.all_params.isCoupon = -1;
                }
                //京东自营
                if (check_values.includes(this.check_list[1])) {
                    this.all_params.owner = "g";
                } else {
                    this.all_params.owner = "";
                }
                // //拼购
                // if (check_values.includes(this.check_list[2])) {
                //     this.all_params.isPG = 1;
                // } else {
                //     this.all_params.isPG = -1;
                // }
                // //爆款
                // if (check_values.includes(this.check_list[3])) {
                //     this.all_params.isHot = 1;
                // } else {
                //     this.all_params.isHot = -1;
                // }

                this.clickToSearch();
            },

            /**
             * 根据条件查询数据
             */
            clickToSearch() {

                this.initStatus();

                this.all_params.keyword = this.search_value;

                // if(this.url.indexOf("keyword") !== -1){
                //     let sub_str = this.url.substring(this.url.indexOf("?") + 1, this.url.indexOf("&") + 1);
                //     // console.log(sub_str)
                //     this.url = this.url.replace(sub_str,"");
                // }

                // if(this.url.indexOf("keyword") !== -1){
                //     if(this.url.indexOf("[word]") !== -1){
                //         this.url = this.url.replace("[word]", "");
                //     }else{
                //         let sub_str = this.url.substring(this.url.indexOf("keyword=") + 8, this.url.indexOf("&"));
                //         console.log("this.search_value = " +this.search_value)
                //         if(this.search_value){
                //             this.url = this.url.replace(sub_str, this.search_value);
                //         }
                //     }
                //     // this.url = this.url.replace(sub_str,"");
                // }

                console.log(this.url)
                //手动调用onLoad方法获取数据
                this.$refs.Wp_pull_list.clickToLoad();
            },

            initStatus() {
                this.data_list = [];
                // this.all_params.pageIndex = 1;
                this.$refs.Wp_pull_list.initStatus();
            },
        }
    }
</script>

<style scoped>

    .top_tools_div{
        width: 100%;
        min-height: 80px;
        position: fixed;
        top: 0px;
        z-index: 1999;
        padding-bottom: 5px;
        /*box-shadow: 0px 1px 5px #999*/
    }
</style>